// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import { InteractionPreferencesProvider } from './contexts/InteractionPreferencesContext';
import { ToastProvider } from './contexts/ToastContext';

const resolveRootApp = () => {
  const { isPublicTrackingEntryPoint } = require('./utils/publicTracking');
  if (isPublicTrackingEntryPoint()) {
    return require('./PublicApp').default;
  }

  return require('./App').default;
};

const RootApp = resolveRootApp();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <InteractionPreferencesProvider>
      <ToastProvider>
        <RootApp />
      </ToastProvider>
    </InteractionPreferencesProvider>
  </React.StrictMode>
);

// Убираем splash screen после монтирования
const splash = document.getElementById('splash');
if (splash) {
  // Небольшая задержка чтобы первый рендер успел отрисоваться
  setTimeout(() => {
    splash.classList.add('hidden');
    setTimeout(() => splash.remove(), 400);
  }, 300);
}
